import React from 'react'
//import PropTypes from 'prop-types'
import Controls from './controls'

const Default = (props) => {
	return (
		<React.Fragment>
			<Controls />
			<div id="video-player"></div>
		</React.Fragment>
	)
}

Default.propTypes = {}

export default Default


// WEBPACK FOOTER //
// ./src/mobile/components/video-player/default.js